import { Stack } from '@gcl/react-core';
import * as React from 'react';
import { DetailPageRightMenuGeneralInfo, IDetailPageRightMenuGeneralInfoProps } from './DetailPageRightMenuGeneralInfo';
import { DetailPageRightMenuTemporaryWorksForms } from './DetailPageRightMenuTemporaryWorksForms';
import './DetailPageRightMenu.scss';

interface IDetailPageRightMenuProps extends IDetailPageRightMenuGeneralInfoProps {
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DetailPageRightMenu: React.FunctionComponent<IDetailPageRightMenuProps> = ({
  setIsDrawerOpen,
  ...props
}) => {
  return (
    <Stack gap={3} className="gcl-gems-detail-right-menu-content">
      <DetailPageRightMenuGeneralInfo {...props} />
      <DetailPageRightMenuTemporaryWorksForms
        masterSchedule={props.masterSchedule}
        masterScheduleId={props.masterSchedule?.id}
        masterScheduleIsCancelled={props.masterSchedule?.isCancelled}
        masterScheduleIsLocked={props.masterSchedule?.isLocked}
        setIsDrawerOpen={setIsDrawerOpen}
      />
    </Stack>
  );
};
